import { Empty, styled } from '@yunex/yds-react';
import React, { memo } from 'react';
import { CMP_LOADING_OR_EMPTY_STATE as CMP } from '../../componentNames';
var StyledEmpty = styled(Empty)({
    paddingTop: 20,
    height: '100%',
    justifyContent: 'center',
});
var LoadingOrEmptyState = memo(function (_a) {
    var title = _a.title, description = _a.description, action = _a.action, icon = _a.icon, sx = _a.sx;
    return (React.createElement(StyledEmpty, { action: action, "data-testid": "".concat(CMP, "-root"), description: description, icon: icon, sx: sx, title: title }));
});
LoadingOrEmptyState.displayName = CMP;
export default LoadingOrEmptyState;
//# sourceMappingURL=LoadingOrEmptyState.js.map